<template>
    <div>
        <div class="bg white s_1280">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-6">
                            <img class="logo-img" src="images/logo.png" />
                        </div>
                        <div class="col-6">
                            <div class="navigation">
                                <!--<a class="apply-btn" href="/#/newvisa">Apply Now</a>-->
                                <a class="apply-btn" href="/#/newvisa">Apply Now</a>
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="explore">
                <a href="#about"><div class="elipse-white"></div><label class="small-light-blue">Explore Botswana</label></a>
            </div>
            <div class="container-fluid top64 wrapper">
                <div class="row">
                    <div class="col-6">
                        <h1 class="eVisah-h1">e-Visa Botswana</h1>
                    </div>
                    <div class="col-6" id="check-country">
                        <CheckCountry></CheckCountry>
                    </div>
                    <div class="col-6 offset-md-6 top64">
                        <div class="visa-box">
                            <h3>Continue Submission</h3>
                            <p>Continue the online Visa Application process</p>
                            <router-link to="/authorise">
                                <button type="button" class="btn btn-outline-info">Continue Submission</button>
                            </router-link>
                        </div>
                        <div class="visa-box">
                            <h3>Check status</h3>
                            <p>Check the status of Visa Application </p>
                            <router-link to="/authorise">
                                <button type="button" class="btn btn-outline-info">Check Status</button>
                            </router-link>
                        </div>
                    </div>
                </div>

            </div>
            <div class="zebrot">
                <div class="half">
                    <a id="about">
                        <h1>About Botswana</h1>
                    </a>
                    <p>
                        Botswana, a landlocked African country known for its political stability and multi- party democracy, is widely regarded as having some of the best wilderness and wildlife areas on the African Continent


                    </p>
                </div>
                <div class="half">
                    <div class="half-wrapper">
                        <div class="width-s2">
                            <h2>30</h2>
                        </div>
                        <div class="width-s1"><span>{{domDecoder(celsius)}}</span></div>
                        <div class="width-s4">
                            <p class="small-p">Average temperature for the year</p>
                        </div>
                    </div>
                    <div class="half-wrapper second">
                        <div class="width-s3">
                            <h2>581,730</h2>
                        </div>
                        <div class="width-s1"><span>{{domDecoder(squarekm)}}</span></div>
                        <div class="width-s3">
                            <p class="small-p">Territory of the country</p>
                        </div>
                    </div>
                    <div class="half-wrapper second">
                        <div class="ellipse"></div>
                        <label class="small-blue" v-on:click="readMore(1)">Read more</label>
                    </div>
                </div>
            </div>
            <div class="container-fluid">
                <div class="row">
                    <div class="col-4 offset-md-8">
                        <div class="btm-right-square">
                            <a id="link-1" class="active" v-on:click="openTab(1, 'About Botswana')">About Botswana </a>
                            <a id="link-2" v-on:click="openTab(2, 'Location')">Location</a>
                            <a id="link-3" v-on:click="openTab(3, 'Climate')">Climate</a>

                            <div id="t-head" class="heading">About Botswana</div>
                            <div class="b-tab" id="tab-1">
                                <p>
                                    Welcome to Botswana,
                                </p>
                                <p>
                                    a landlocked African country known for its political stability and multi- party democracy, is widely regarded as having some of the best wilderness and wildlife areas on the African Continent. With a full 38 percent of its total land area devoted to national parks,  reserves  and  wildlife  management  areas  -  for  mostly  part  unfenced  -  allowing animals  to  roam  wildly  and  free -  travelling  through  many  parts  of  the  country  has  a feeling of moving through an immense nature wonderland.
                                </p>

                                <div id="ell-1" v-on:click="readMore(1)" class="ellipse-light closed"></div>
                                <label id="lbl-1" v-on:click="readMore(1)" class="small-light-blue">Read more</label>
                            </div>
                            <div class="b-tab" id="tab-2" style="display: none;">
                                <p>Botswana is a land-locked country dominated in geographical terms by the Kalahari Desert - a sand-filled basin averaging 1,100 metres above sea level. The country lies between longitudes 20 and 30 degrees east of Greenwich and between the latitudes 18 and 27 degrees approximately south of the Equator.</p>
                                <div id="ell-2" v-on:click="readMore(2)" class="ellipse-light closed"></div>
                                <label id="lbl-2" v-on:click="readMore(2)" class="small-light-blue">Read more</label>
                            </div>
                            <div class="b-tab" id="tab-3" style="display: none;">
                                <p>Botswana's climate is semi-arid. Though it is hot and dry for much of the year, there is a rainy season, which runs through the summer months. Rainfall tends to be erratic, unpredictable and highly regional. Often a heavy downpour may occur in one area while 10 or 15 kilometres away there is no rain at all. Showers are often followed by strong sunshine so that a good deal of the rainfall does not penetrate the ground but is lost to evaporation and transpiration.</p>
                                <div id="ell-3" v-on:click="readMore(3)" class="ellipse-light closed"></div>
                                <label id="lbl-3" v-on:click="readMore(3)" class="small-light-blue">Read more</label>
                            </div>


                        </div>
                    </div>
                </div>
            </div>
        </div>

        <modal name="hello-world"
               :width="960"
               :height="860">
            <div class="modal-form temp">
                <div class="logo"><img src="images/logo.png"></div>
                <h3>MINISTRY OF LABOUR AND HOME AFFAIRS</h3>
              

                <h2 style="color:red;">IMPORTANT NOTICE</h2>
                <p>
                    The Ministry of Labour and Home Affairs (Department of Immigration and Citizenship) advises its clientele that the payment gateway for online VISA applications has been restored and as such the application platform is back to normal.
                </p>
                <h3 style="color:red;">Registration of New VISA applications is now resuscitated with effect from 27th December 2022.</h3>
                <p><b>In this regard, applications that were paid during the period 14th October 2022 up to 26th December 2022 will be fully refunded through the Bank.</b> </p>
                <p>Any inconveniences caused by the non-functionality of the system is greatly regretted.</p>

                <!--
    <h2>IMPORTANT NOTICE</h2>
    <p>
        The Ministry of Labour and Home Affairs (Department of Immigration and Citizenship) advises its clientele that the payment gateway for online VISA applications has been restored and as such the application platform is back to normal.
    </p>
    <p style="color:red;">Registration of New VISA applications is now resuscitated with effect from 22nd December 2022. </p>
    <p><b>In this regard, applications that were paid during the period 14thOctober 2022 up to 21st December 2022 will be fully refunded through the Bank.</b></p>
    <p>Any inconveniences caused by the non-functionality of the system is greatly regretted.</p>
    -->


                <p>For any other queries please contact the Help-Desk for assistance using the following:</p>
                <p>TELEPHONE: <b>+267 3611300/02/27/40/43</b></p>
                <p>E-mail Addresses:</p>
                <p>General Enquiries: <b>immigration-admin@gov.bw</b></p>
                <p>Technical Support: <b>evisa-support@gov.bw</b></p>
                <p>Thank you.</p>
                <div class="submit-row">
                    <button @click="hide" type="button" class="btn-submit">Close</button>
                </div>
            </div>
        </modal>

        <div class="bg white s_768">
            <div class="d-flex flex-column flex-md-row align-items-center mb-3 bg-white">
                <div class="container-fluid wrapper index">
                    <div class="nav-top row">
                        <div class="col-4">
                            <img class="logo-img" src="images/logo.png" />
                        </div>
                        <div class="col-8">
                            <div class="navigation">
                                <a class="apply-btn" href="/#/newvisa">Apply Now</a>
                                <TopMenu :ShowContinueSubmission=true></TopMenu>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="explore">
                <a href="#about-botswana"><div class="elipse-white"></div><label class="small-light-blue">Explore Botswana</label></a>
            </div>
            <div class="row">
                <div class="col-12">
                    <h1 class="eVisah-h1">e-Visa Botswana</h1>
                </div>
                <div class="col-12" id="check-country">
                    <CheckCountry></CheckCountry>
                </div>

            </div>
            <div class="row">
                <div class="col-6">
                    <div class="visa-box">
                        <h3>Continue Submission</h3>
                        <p>Continue the online Visa Application process</p>
                        <router-link to="/authorise">
                            <button type="button" class="btn btn-outline-info">Continue Submission</button>
                        </router-link>
                    </div>
                </div>
                <div class="col-6">
                    <h3>Check status</h3>
                    <p>Check the status of Visa Application </p>
                    <router-link to="/authorise">
                        <button type="button" class="btn btn-outline-info">Check Status</button>
                    </router-link>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder top98">
                        <img src="/images/bird-768.jpg" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="black-box">
                        <div class="black-box-half">
                            <a id="about-botswana">
                                <h1>About Botswana</h1>
                            </a>
                            <p>
                                Botswana, a landlocked African country known for its political stability and multi- party democracy, is widely regarded as having some of the best wilderness and wildlife areas on the African Continent
                            </p>
                        </div>
                        <div class="black-box-half">
                            <div>
                                <h2>30</h2>
                                <span>{{domDecoder(celsius)}}</span>
                                <p>Average temperature for the year</p>
                                <h2 class="square">581,730</h2>
                                <span>{{domDecoder(squarekm)}}</span>
                                <p>Territory of the country</p>
                                <div class="read-more">
                                    <div class="ellipse"></div>
                                    <label class="small-blue" v-on:click="readMore(1)">Read more</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="placeholder">
                        <img src="/images/zebrot-768.jpg" />
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-12">
                    <div class="btm-right-square">
                        <a id="link-5" class="active" v-on:click="openTab(5, 'About Botswana')">About Botswana </a>
                        <a id="link-6" v-on:click="openTab(6, 'Location')">Location</a>
                        <a id="link-7" v-on:click="openTab(7, 'Climate')">Climate</a>

                        <div id="t-head" class="heading">About Botswana</div>
                        <div class="b-tab" id="tab-5">
                            <p>
                                Welcome to Botswana,
                            </p>
                            <p>
                                a landlocked African country known for its political stability and multi- party democracy, is widely regarded as having some of the best wilderness and wildlife areas on the African Continent. With a full 38 percent of its total land area devoted to national parks,  reserves  and  wildlife  management  areas  -  for  mostly  part  unfenced  -  allowing animals  to  roam  wildly  and  free -  travelling  through  many  parts  of  the  country  has  a feeling of moving through an immense nature wonderland.
                            </p>

                            <div id="ell-5" v-on:click="readMore(1)" class="ellipse-light closed"></div>
                            <label id="lbl-5" v-on:click="readMore(1)" class="small-light-blue">Read more</label>
                        </div>
                        <div class="b-tab" id="tab-6" style="display: none;">
                            <p>Botswana is a land-locked country dominated in geographical terms by the Kalahari Desert - a sand-filled basin averaging 1,100 metres above sea level. The country lies between longitudes 20 and 30 degrees east of Greenwich and between the latitudes 18 and 27 degrees approximately south of the Equator.</p>
                            <div id="ell-6" v-on:click="readMore(2)" class="ellipse-light closed"></div>
                            <label id="lbl-6" v-on:click="readMore(2)" class="small-light-blue">Read more</label>
                        </div>
                        <div class="b-tab" id="tab-7" style="display: none;">
                            <p>Botswana's climate is semi-arid. Though it is hot and dry for much of the year, there is a rainy season, which runs through the summer months. Rainfall tends to be erratic, unpredictable and highly regional. Often a heavy downpour may occur in one area while 10 or 15 kilometres away there is no rain at all. Showers are often followed by strong sunshine so that a good deal of the rainfall does not penetrate the ground but is lost to evaporation and transpiration.</p>
                            <div id="ell-7" v-on:click="readMore(3)" class="ellipse-light closed"></div>
                            <label id="lbl-7" v-on:click="readMore(3)" class="small-light-blue">Read more</label>
                        </div>


                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import CheckCountry from "./CheckCountry";
    import TopMenu from "./Menu";
    

    export default {
        name: 'Home',
        components: {
            CheckCountry,
            TopMenu

        },
        data: () => ({
            temperature: "",
            celsius: "&#8451",
            squarekm: "&#13218"
        }),
        mounted() {
            //this.getWheather()
            //this.show();
        },
        methods: {
          
            async getWheather() {
                try {
                    const response = await fetch(this.$apiip + '/api/v1/application/wheather')
                    const data = await response.json()
                    this.temperature = data
                } catch (error) {
                    //console.error(error)
                }
            },
            domDecoder(str) {
                let parser = new DOMParser();
                let dom = parser.parseFromString('<!doctype html><body>' + str, 'text/html');
                return dom.body.textContent;
            },
            openTab(id, name) {
                $('.b-tab').hide();
                $('.btm-right-square a').removeClass('active');
                $('#tab-' + id).show();
                $('#link-' + id).addClass('active');
                $('#t-head').html(name);
            },
            readMore(id) {
                switch (id) {
                    case 1:
                        this.$router.push('about');
                        break;
                    case 2:
                        this.$router.push('location');
                        break;
                    case 3:
                        this.$router.push('climate');
                        break;
                }
            },
            show() {
                this.$modal.show('hello-world');
            },
            hide() {
                this.$modal.hide('hello-world');
            }
        },
        props: {
            msg: String
        },
    }
</script>


